export const events = [
  {
    id: 1,
    slug: "sigmma-machines-saudi-metal-expo-2026",

    title: "Sigma Machines at Saudi Metal & Steel Expo 2026",
    title_ar: "سيجما ماشينز في معرض السعودية للمعادن والصلب 2026",

    image: "/events/saudi-metal-expo.jfif",

    category: "Exhibition",
    category_ar: "معرض",

    date: "March 2026",
    date_ar: "مارس 2026",

    keywords:
      "Saudi Metal Expo, CNC Machines, Sigma Machines, Industrial Exhibition, Saudi Arabia Manufacturing",

    description:
      "Sigma Machines showcased advanced CNC and fiber laser solutions at Saudi Metal & Steel Expo 2026.",

    description_ar:
      "شاركت شركة سيجما ماشينز في معرض السعودية للمعادن والصلب 2026 واستعرضت أحدث حلول CNC والفايبر ليزر.",

    excerpt:
      "Sigma Machines presented its latest industrial machinery solutions at one of the biggest exhibitions in Saudi Arabia.",

    excerpt_ar:
      "قدمت سيجما ماشينز أحدث حلول الماكينات الصناعية في أحد أكبر المعارض في السعودية."
  },

  {
    id: 2,
    slug: "jeddah-industrial-technology-forum-2026",

    title: "Jeddah Industrial Technology Forum 2026",
    title_ar: "ملتقى جدة للتكنولوجيا الصناعية 2026",

    image: "/events/jeddah-forum.jfif",

    category: "Forum",
    category_ar: "ملتقى",

    date: "May 2026",
    date_ar: "مايو 2026",

    keywords:
      "Jeddah Forum, Industrial Technology, CNC Automation, Smart Factory Saudi",

    description:
      "Sigma Machines participated in discussions about smart factories and Industry 4.0 solutions.",

    description_ar:
      "شاركت سيجما ماشينز في مناقشات حول المصانع الذكية وحلول الصناعة 4.0.",

    excerpt:
      "Industry leaders gathered to discuss the future of manufacturing and automation in Saudi Arabia.",

    excerpt_ar:
      "اجتمع قادة الصناعة لمناقشة مستقبل التصنيع والأتمتة في السعودية."
  },

  {
    id: 3,
    slug: "riyadh-cnc-technology-showcase-2026",

    title: "Riyadh CNC Technology Showcase 2026",
    title_ar: "عرض تقنيات CNC في الرياض 2026",

    image: "/events/riyadh-cnc-showcase.jfif",

    category: "Showcase",
    category_ar: "عرض تقني",

    date: "February 2026",
    date_ar: "فبراير 2026",

    keywords:
      "Riyadh Exhibition, CNC Machines, Laser Cutting, Industrial Machinery Saudi",

    description:
      "Live demonstration of CNC and laser cutting machines for industrial clients.",

    description_ar:
      "عرض مباشر لماكينات CNC وقص الليزر أمام العملاء الصناعيين في الرياض.",

    excerpt:
      "Visitors experienced live demonstrations of advanced CNC technology and automation systems.",

    excerpt_ar:
      "شاهد الزوار عروضًا حية لأحدث تقنيات CNC وأنظمة الأتمتة."
  },

  {
    id: 4,
    slug: "sigmma-machines-partnership-signing-saudi-factory",

    title: "Strategic Partnership Signing with Saudi Factory",
    title_ar: "توقيع شراكة استراتيجية مع مصنع سعودي",

    image: "/events/partnership-signing.jfif",

    category: "Partnership",
    category_ar: "شراكة",

    date: "April 2026",
    date_ar: "أبريل 2026",

    keywords:
      "Industrial Partnership, CNC Factory, Sigma Machines Saudi Arabia, Manufacturing Agreement",

    description:
      "Sigma Machines signed a strategic agreement to supply CNC machines to a major Saudi factory.",

    description_ar:
      "وقعت سيجما ماشينز اتفاقية استراتيجية لتوريد ماكينات CNC لأحد المصانع الكبرى في السعودية.",

    excerpt:
      "The partnership aims to enhance production capabilities and industrial automation in the region.",

    excerpt_ar:
      "تهدف الشراكة إلى تطوير القدرات الإنتاجية وتعزيز الأتمتة الصناعية."
  },

  {
    id: 5,
    slug: "factory-visit-sigma-machines-demo-center-saudi-arabia",

    title: "Factory Visit at Sigma Machines Demo Center",
    title_ar: "زيارة مصنع سيجما ماشينز التجريبي",

    image: "/events/factory-visit.jfif",

    category: "Open House",
    category_ar: "زيارة ميدانية",

    date: "June 2026",
    date_ar: "يونيو 2026",

    keywords:
      "Factory Visit, CNC Demo, Industrial Machinery Saudi, Sigma Machines Showroom",

    description:
      "Clients visited Sigma Machines demo center to explore live CNC machine operations.",

    description_ar:
      "قام العملاء بزيارة مركز سيجما ماشينز التجريبي لمشاهدة تشغيل ماكينات CNC مباشرة.",

    excerpt:
      "Visitors explored live machine demonstrations and discussed industrial solutions with experts.",

    excerpt_ar:
      "استكشف الزوار تشغيل الماكينات مباشرة وتناقشوا مع خبراء الحلول الصناعية."
  }
];